import React, { Component } from "react";
import {
  Row,
  Button,
  Col,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  CardTitle,
} from "reactstrap";
import PanelHeader from "../../../components/PanelHeader/PanelHeader";
import PackinglistAll from "./PrintAll/PackinglistAll";
import CsvGen from "./PrintAll/CsvGen";
import { ScreenSize } from "helper/ScreenSize";

var packingStyle = {
  textColor: {
    color: "#3787C6",
  },
  backbtn: {
    position: "absolute",
    top: "10px",
  },
  printMenu: {
    position: "absolute",
    top: "18%",
    left: "100px",
  },
  fixedElement: {
    position: "fixed",
    width: 250,
    height: 80,
  },
};

class Packinglistprint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anID: [],
      colSize1: 2,
      colSize2: 8,
      colSize3: 2,
    };
  }

  componentDidMount() {
    let screenSize = ScreenSize(window.innerWidth, window.innerHeight);

    if (screenSize === 1 || screenSize === 2) {
      this.setState({
        colSize1: 12,
        colSize2: 12,
        colSize3: 12,
      });
    }

    // Important: do not mutate state directly; use setState so children re-render.
    this.setState({ anID: [this.props.match.params.id] });
  }

  // withOrWithOutMenu = () => {
  //   if (this.state.isLoading !== true && this.state.jobType.length > 0) {
  //     if (this.state.jobType[0].value !== "Cocktailkursus") {
  //       //console.log(this.state.jobType[0].value);
  //       return (
  //         <DropdownItem
  //           onClick={() => {
  //             this.props.history.push(
  //               `/bookings/${this.props.match.params.id}/menu`
  //             );
  //           }}
  //         >
  //           Menu
  //         </DropdownItem>
  //       );
  //     }
  //   }
  // };

  render() {
    const { colSize3, colSize2, colSize1 } = this.state;
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12} md={colSize1}>
              <Card className="card-chart ">
                <CardHeader style={{ fontWight: "bold", textAlign: "center" }}>
                  csv
                </CardHeader>
                <CardBody style={{ textAlignLast: "center" }}>
                  <CsvGen refreshApi={true} jobid={this.state.anID} />{" "}
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} md={colSize2} className="mr-auto">
              <Card className="card-chart ">
                <CardHeader>
                  <CardTitle>Print</CardTitle>
                </CardHeader>
                <CardBody>
                  <PackinglistAll
                    listOfId={this.state.anID}
                    refreshApi={true}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} md={colSize3}>
              <Card>
                <CardBody>
                  <Button                    
                    color="danger"
                    onClick={() => {
                      this.props.history.push(
                        `/bookingoverview/bookings/${this.props.match.params.id}`
                      );
                    }}
                  >
                    Back
                  </Button>
                  <UncontrolledDropdown style={packingStyle.printMenu}>
                    <DropdownToggle
                      style={{ backgroundColor: "#d16557" }}
                      caret
                      color="info"
                    >
                      Print
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem
                        style={{ color: "#d16557" }}
                        onClick={() => {
                          this.props.history.push(
                            `/bookingoverview/bookings/${this.props.match.params.id}/packinglistprint`
                          );
                        }}
                      >
                        Packing List
                      </DropdownItem>
                      <DropdownItem
                        style={{ color: "#d16557" }}
                        onClick={() => {
                          this.props.history.push(
                            `/bookingoverview/bookings/${this.props.match.params.id}/frontpage`
                          );
                        }}
                      >
                        Front page
                      </DropdownItem>
                      {/* {this.withOrWithOutMenu()} */}
                      <DropdownItem
                        style={{ color: "#d16557" }}
                        onClick={() => {
                          this.props.history.push(
                            `/bookingoverview/bookings/${this.props.match.params.id}/specsheet`
                          );
                        }}
                      >
                        Specsheet
                      </DropdownItem>
                      <DropdownItem
                        style={{ color: "#d16557" }}
                        onClick={() => {
                          this.props.history.push(
                            `/bookingoverview/bookings/${this.props.match.params.id}/returliste`
                          );
                        }}
                      >
                        Returliste
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Packinglistprint;
